import { create } from 'zustand';

import { createAbsencesSlice } from './slices/absences';
import { createApplicationSlice } from './slices/application';
import { createContactsSlice } from './slices/contacts';
import { createDealsSlice } from './slices/deals';
import { createFeedbackSlice } from './slices/feedback';
import { createJiraSlice } from './slices/jira';
import { createProjectsSlice } from './slices/projects';
import { createSessionSlice } from './slices/session';
import { createTendersSlice } from './slices/tenders';
import { createTimelineSlice } from './slices/timeline';
import { createTimesheetsSlice } from './slices/timesheets';
import { createUsersSlice } from './slices/users';

/* État de l'application, découpé en tranches par domaine (voir ./slices). Chaque setter accepte
   une valeur ou une fonction de mise à jour, comme useState. */
export const useAppStore = create((set) => ({
  ...createApplicationSlice(set),
  ...createSessionSlice(set),
  ...createUsersSlice(set),
  ...createAbsencesSlice(set),
  ...createTimesheetsSlice(set),
  ...createJiraSlice(set),
  ...createProjectsSlice(set),
  ...createDealsSlice(set),
  ...createTendersSlice(set),
  ...createContactsSlice(set),
  ...createTimelineSlice(set),
  ...createFeedbackSlice(set),
}));
